import { ArchiveBoxIcon, XMarkIcon } from '@heroicons/react/24/outline'
import type { Application } from '../../types'

type Props = {
  app: Application | null
  onClose: () => void
  onConfirm: (appId: string) => void
}

export const ArchiveConfirmationModal = ({
  app,
  onClose,
  onConfirm,
}: Props) => {
  if (!app) return null

  const handleConfirm = () => {
    onConfirm(app.id)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-sm border border-app-line bg-app-surface p-4 space-y-4 rounded-2xl shadow-app-card">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-app-ink flex items-center gap-2">
            <ArchiveBoxIcon className="h-4 w-4 text-app-muted" aria-hidden="true" />
            Archive application
          </p>
          <button
            onClick={onClose}
            className="text-app-muted hover:text-app-ink"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <p className="text-sm text-app-muted">
          Are you sure you want to archive <span className="font-semibold text-app-ink">{app.company}</span>?
        </p>
        <p className="text-xs text-app-muted">
          You can restore it later from the archive view.
        </p>

        <div className="flex justify-end gap-2 pt-2">
          <button
            onClick={onClose}
            className="rounded-lg border border-app-line px-4 py-2 text-sm font-semibold text-app-ink hover:bg-app-subtle"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="rounded-lg bg-app-surface px-4 py-2 text-sm font-semibold text-app-ink hover:bg-app-surface"
          >
            Archive
          </button>
        </div>
      </div>
    </div>
  )
}

